module.exports = __webpack_public_path__ + "static/029.thumb-94e656a4b61cafdf2ea3a21dea245b71.jpg";